let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fpWd0")).then(() => parcelRequire('lbCLP'));